import { getActionTypes } from './get-actions';
import { getInitialState } from './get-initial-state';

const initialState = getInitialState();

export const getReducer = (actionPrefix) => (action) => ({
  // START
  [getActionTypes(actionPrefix).QUERY_START]: () => ({
    isLoading: true,
    isQueryPending: true,
  }),
  [getActionTypes(actionPrefix).MUTATION_START]: () => ({
    isLoading: true,
    isMutationPending: true,
  }),
  [getActionTypes(actionPrefix).MUTATION_PRIVACY_START]: () => ({
    isMutationPrivacyPending: true,
  }),
  [getActionTypes(actionPrefix).SUBSCRIPTION_START]: () => ({
    unsubscribe: action.payload.unsubscribe,
  }),

  // SUCCESS
  [getActionTypes(actionPrefix).QUERY_SUCCESS]: () => ({
    allUserPreferences: action.payload.data.allUserPreferences,
    contents: action.payload.data.contents,
    contentsByUserPreferences: action.payload.data.contentsByUserPreferences,
    videoContents: action.payload.data.videoContents,
    userPreferences: action.payload.data.userPreferences,
    selectedOptions: action.payload.data.userPreferences.filter((preference) => preference.enabled),
    widgetPreferences: action.payload.data.widgetPreferences,
    widgetHeading: action.payload.data.widgetHeading,
    messages: action.payload.data.messages,
    isLoading: false,
    error: initialState.error,
    isQueryPending: false,
  }),
  [getActionTypes(actionPrefix).MUTATION_SUCCESS]: () => ({
    // selectedOptions: initialState.selectedOptions,
    error: initialState.error,
    isMutationPending: false,
    isSubscriptionPending: true,
  }),
  [getActionTypes(actionPrefix).SUBSCRIPTION_NEW_DATA_SUCCESS]: () => ({
    allUserPreferences: action.payload.data.allUserPreferences,
    contents: action.payload.data.contents,
    contentsByUserPreferences: action.payload.data.contentsByUserPreferences,
    videoContents: action.payload.data.videoContents,
    userPreferences: action.payload.data.userPreferences,
    selectedOptions: action.payload.data.userPreferences.filter((preference) => preference.enabled),
    widgetPreferences: action.payload.data.widgetPreferences,
    widgetHeading: action.payload.data.widgetHeading,
    messages: action.payload.data.messages,
    isLoading: false,
    isSubscriptionPending: false,
  }),
  [getActionTypes(actionPrefix).MUTATION_PRIVACY_SUCCESS]: () => ({
    error: initialState.error,
    isMutationPrivacyPending: false,
  }),

  // FAILURE
  [getActionTypes(actionPrefix).QUERY_FAILURE_GENERIC]: () => ({
    unsubscribe: initialState.unsubscribe,
    error: {
      status: action.payload.error?.status,
      code: action.payload.error?.code,
      message: action.payload.error?.message,
    },
    isQueryPending: false,
  }),
  [getActionTypes(actionPrefix).SUBSCRIPTION_FAILURE]: () => ({
    unsubscribe: initialState.unsubscribe,
    error: {
      status: action.payload.error?.status,
      code: action.payload.error?.code,
      message: action.payload.error?.message,
    },
    isSubscriptionPending: false,
  }),
  [getActionTypes(actionPrefix).QUERY_FAILURE_401]: () => ({
    unsubscribe: initialState.unsubscribe,
    error: {
      status: action.payload.error?.status,
      code: action.payload.error?.code,
      message: action.payload.error?.message,
    },
  }),
  [getActionTypes(actionPrefix).MUTATION_FAILURE_GENERIC]: () => ({
    error: {
      status: action.payload.error?.status,
      code: action.payload.error?.code,
      message: action.payload.error?.message,
    },
    isMutationPending: false,
    isLoading: false,
  }),
  [getActionTypes(actionPrefix).MUTATION_PRIVACY_FAILURE_GENERIC]: () => ({
    error: {
      status: action.payload.error?.status,
      code: action.payload.error?.code,
      message: action.payload.error?.message,
    },
    isMutationPrivacyPending: false,
  }),
  [getActionTypes(actionPrefix).MUTATION_FAILURE_401]: () => ({
    error: {
      status: action.payload.error?.status,
      code: action.payload.error?.code,
      message: action.payload.error?.message,
    },
  }),
  [getActionTypes(actionPrefix).MUTATION_PRIVACY_FAILURE_401]: () => ({
    error: {
      status: action.payload.error?.status,
      code: action.payload.error?.code,
      message: action.payload.error?.message,
    },
  }),

  // USER INTERACTION
  [getActionTypes(actionPrefix).OPEN_PREFERENCES_LIST]: () => ({
    showPreferencesList: true,
  }),
  [getActionTypes(actionPrefix).CLOSE_PREFERENCES_LIST]: () => ({
    showPreferencesList: false,
  }),
  [getActionTypes(actionPrefix).UPDATE_MESSAGES]: () => ({
    messages: action.payload.messages,
  }),
  [getActionTypes(actionPrefix).SELECT_OPTIONS]: () => ({
    selectedOptions: action.payload.options,
  }),
});
